import React from 'react';
import { motion } from 'framer-motion';
import { RocketGradient } from './LogoGradients';
import {
  ROCKET_ANIMATION, ROCKET_TRANSITION, FIRE_ANIMATION, FIRE_TRANSITION, SPARKLE_ANIMATION, SPARKLES,
} from './logoMotion';

export const LogoRocket = () => (
  <motion.div className="absolute -top-2 -right-2" animate={ROCKET_ANIMATION} transition={ROCKET_TRANSITION}>
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none" className="drop-shadow-lg">
      <path d="M16 3L20 12L16 21L12 12L16 3Z" fill="url(#rocketGrad)" stroke="#FFD93D" strokeWidth="1" />
      <circle cx="16" cy="12" r="2.5" fill="#4ECDC4" opacity="0.9" />
      <path d="M12 12L9 18L12 15Z" fill="#FF6B35" stroke="#F7931E" strokeWidth="0.5" />
      <path d="M20 12L23 18L20 15Z" fill="#FF6B35" stroke="#F7931E" strokeWidth="0.5" />
      <motion.g animate={FIRE_ANIMATION} transition={FIRE_TRANSITION}>
        <path d="M13 21L16 28L19 21Z" fill="#FFD93D" />
        <path d="M14 21L16 26L18 21Z" fill="#FF6B35" opacity="0.8" />
      </motion.g>
      {SPARKLES.map((s) => (
        <motion.circle
          key={`${s.cx}-${s.cy}`}
          cx={s.cx}
          cy={s.cy}
          r="1"
          fill={s.fill}
          animate={SPARKLE_ANIMATION}
          transition={s.transition}
        />
      ))}
      <RocketGradient />
    </svg>
  </motion.div>
);
